import VModal from 'vue-js-modal'
import VueGlide from 'vue-glide-js'
import Vue from 'vue'

require('./bootstrap')

try {
    window.$ = window.jQuery = require('jquery')
} catch (e) {}

require('./components/HomepageAnimations/animate.js')

Vue.use(VModal)
Vue.use(VueGlide)

import registerForm from './components/RegisterForm.vue'
import signupForm from './components/RegisterForm.vue'
import videogallery from './components/VideoGallery.vue'
import imageslider from './components/ImageSlider.vue'
import imagepopup from './components/HomepageAnimations/imagepopup.vue'

const app = new Vue({
    el: '#app',
    components: {
        registerForm,
        signupForm,
        videogallery,
        imageslider,
        imagepopup,
    },
})
